<template>
  <IframeCmp type="123" />
</template>

<script>
import IframeCmp from './cmp/IframeCmp';

export default {
  // 应收结算看板
  name: 'ReceivableSettlementDashboard',
  components: {
    IframeCmp
  },
  data() {
    return {

    };
  }
};
</script>
